import React from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import { ValueWrapper } from 'components/Common/OfferPricing/styles'
import Pill from 'components/Luxkit/Pill'
import CruiseDiscountTermsAndConditions from 'components/Cruises/CruiseDiscountTermsAndConditions'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TextButton from 'components/Luxkit/Button/TextButton'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import Group from 'components/utils/Group'
import Caption from 'components/Luxkit/Typography/Caption'
import CruiseSearchPrices from './CruiseSearchPrices'

const TaxesAndFees = styled.div`
  min-width: ${rem(200)};
  align-self: center;
  height: 100%;
`

const PricesWrapper = styled.div`

  padding: ${rem(20)};
`

const Prices = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(16)};
  padding-top: ${rem(16)};
  ${mediaQueryUp.desktop} {
    padding-top: unset;
    display: flex;
  }
  .taxes-and-fees{
    min-width: ${rem(200)};
    align-self: center;
    height: 100%;
  }
`

interface Props {
  offer: App.CruiseOffer;
  discountPills: App.CruiseDiscountPillDetails | null;
  promotionDetails: App.CruisePromotionDetails | null;
}

function CruiseTileSearchPrices(Props: Props) {
  const { offer, discountPills, promotionDetails } = Props
  const { mainDepartureDetails } = offer
  const { lowestPriceDetailsByCategory } = mainDepartureDetails

  return (
    <PricesWrapper>
      <CSSBreakpoint max="tablet">
        {!offer.disableDeposits && (
          <Group direction="horizontal">
            {promotionDetails?.deposit && (
              <Pill
                  kind="tertiary"
                  variant="primary"
                  startIcon={<LineClockDollarIcon />}
                >
                Secure with a {promotionDetails.deposit.formattedValue} deposit
              </Pill>
            )}
            {!promotionDetails?.deposit && (
              <Pill
                  kind="tertiary"
                  variant="primary"
                  startIcon={<LineClockDollarIcon />}
                >
                Deposits available
              </Pill>
            )}
          </Group>
        )}
      </CSSBreakpoint>
      <Prices>
        <CruiseSearchPrices offer={offer} lowestPriceDetailsByCategory={lowestPriceDetailsByCategory} />
        <CSSBreakpoint className="taxes-and-fees" min="tablet">

          <ValueWrapper variant="large" weight="bold">
            {discountPills?.discountPercentage && (
              <>
                <Pill kind="primary" variant="success">
                  Save up to {discountPills.discountPercentage}%
                </Pill>
                <CruiseDiscountTermsAndConditions />
              </>
            )}
            <BodyText variant="small" colour="neutral-three">All prices include taxes & fees</BodyText>
          </ValueWrapper>
        </CSSBreakpoint>
        <CSSBreakpoint min="tablet" max="tablet">
          <TextButton kind="primary" fit="full-width">
            View offer
          </TextButton>
        </CSSBreakpoint>
      </Prices>
      <CSSBreakpoint max="mobile">
        <Group direction="horizontal" horizontalAlign="space-between">
          <TaxesAndFees>
            <ValueWrapper variant="large" weight="bold">
              {discountPills?.discountPercentage && (
                <>
                  <Pill kind="primary" variant="success">
                    Save up to {discountPills.discountPercentage}%
                  </Pill>
                  <CruiseDiscountTermsAndConditions />
                </>
              )}
              <Caption variant="large" colour="neutral-three">All prices include taxes & fees</Caption>
            </ValueWrapper>
          </TaxesAndFees>
          <TextButton kind="primary" fit="auto">
            View{' '}
          </TextButton>
        </Group>
      </CSSBreakpoint>
    </PricesWrapper>
  )
}

export default CruiseTileSearchPrices
